import { Message } from '../../../entities/ticket/model/types';
import { sendMessage as sendMessageApi } from '../../../entities/ticket/api/ticketApi';

export interface SendMessageRequest {
  ticketId: string;
  content: string;
  attachments?: File[];
  isInternal?: boolean;
}

export class SendMessageUseCase {
  async execute(request: SendMessageRequest): Promise<Message> {
    return await sendMessageApi(
      request.ticketId,
      request.content,
      request.attachments,
      request.isInternal
    );
  }
}




